<template>
  <div class="flex overflow-hidden pt-16 bg-gray-50 ">
    <aside
      id="sidebar"
      class="flex hidden fixed top-0 left-0 z-20 flex-col flex-shrink-0 pt-16 w-64 h-full duration-75 lg:flex transition-width"
      aria-label="Sidebar"
    >
      <div
        class="flex relative flex-col flex-1 pt-0 min-h-0 bg-white border-r border-gray-200  "
      >
        <div class="flex overflow-y-auto flex-col flex-1 pt-5 pb-4">
          <div
            class="flex-1 px-3 space-y-1 bg-white divide-y divide-gray-200  "
          >
            <ul class="pb-2 space-y-2">
              <li>
                <form
                  action="#"
                  method="GET"
                  class="lg:hidden"
                >
                  <label
                    for="mobile-search"
                    class="sr-only"
                  >Search</label>
                  <div class="relative">
                    <div
                      class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none"
                    >
                      <svg
                        class="w-5 h-5 text-gray-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <input
                      id="mobile-search"
                      type="text"
                      name="email"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5      "
                      placeholder="Search"
                    >
                  </div>
                </form>
              </li>
              <li>
                <a
                  href="./index.html"
                  class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 group  "
                >
                  <svg
                    class="w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                    <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                  </svg>
                  <span
                    class="ml-3"
                    sidebar-toggle-item
                  >Dashboard</span>
                </a>
              </li>
              <li>
                <a
                  href="./kanban.html"
                  class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 group   "
                >
                  <svg
                    class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                    />
                  </svg>
                  <span
                    class="flex-1 ml-3 whitespace-nowrap"
                    sidebar-toggle-item
                  >Kanban</span>
                </a>
              </li>
              <li>
                <a
                  href="./mailing/inbox.html"
                  class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:bg-gray-100 group   "
                >
                  <svg
                    class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"
                    />
                    <path
                      d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                    />
                  </svg>
                  <span
                    class="flex-1 ml-3 whitespace-nowrap"
                    sidebar-toggle-item
                  >Inbox</span>
                  <span
                    class="inline-flex justify-center items-center p-1 ml-3 w-5 h-5 text-sm font-medium rounded-full text-primary-800 bg-primary-100"
                    sidebar-toggle-item
                  >3</span>
                </a>
              </li>

              <li>
                <button
                  type="button"
                  class="flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                  aria-controls="dropdown-ecommerce"
                  data-collapse-toggle="dropdown-ecommerce"
                >
                  <svg
                    class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span
                    class="flex-1 ml-3 text-left whitespace-nowrap"
                    sidebar-toggle-item
                  >E-commerce</span>
                  <svg
                    sidebar-toggle-item
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <ul
                  id="dropdown-ecommerce"
                  class="hidden py-2 space-y-2 "
                >
                  <li>
                    <a
                      href="./e-commerce/products.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100   "
                    >Products</a>
                  </li>
                  <li>
                    <a
                      href="./e-commerce/billing.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100   "
                    >Billing</a>
                  </li>
                  <li>
                    <a
                      href="./e-commerce/invoice.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100   "
                    >Invoice</a>
                  </li>
                </ul>
              </li>
              <li>
                <button
                  type="button"
                  class="flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                  aria-controls="dropdown-users"
                  data-collapse-toggle="dropdown-users"
                >
                  <svg
                    class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                    />
                  </svg>
                  <span
                    class="flex-1 ml-3 text-left whitespace-nowrap"
                    sidebar-toggle-item
                  >Users</span>
                  <svg
                    sidebar-toggle-item
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <ul
                  id="dropdown-users"
                  class="hidden py-2 space-y-2 "
                >
                  <li>
                    <a
                      href="./users/list.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100   "
                    >Users
                      list</a>
                  </li>
                  <li>
                    <a
                      href="./users/profile.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100   "
                    >Profile</a>
                  </li>
                  <li>
                    <a
                      href="./users/feed.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Feed</a>
                  </li>
                  <li>
                    <a
                      href="./users/settings.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100   "
                    >Settings</a>
                  </li>
                </ul>
              </li>
              <li>
                <button
                  type="button"
                  class="flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                  aria-controls="dropdown-pages"
                  data-collapse-toggle="dropdown-pages"
                >
                  <svg
                    class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span
                    class="flex-1 ml-3 text-left whitespace-nowrap"
                    sidebar-toggle-item
                  >Pages</span>
                  <svg
                    sidebar-toggle-item
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <ul
                  id="dropdown-pages"
                  class="hidden py-2 space-y-2"
                >
                  <li>
                    <a
                      href="./pages/pricing.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Pricing</a>
                  </li>
                  <li>
                    <a
                      href="./pages/maintenance.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Maintenance</a>
                  </li>
                  <li>
                    <a
                      href="./pages/404.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >404
                      not found</a>
                  </li>
                  <li>
                    <a
                      href="./pages/500.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >500
                      server error</a>
                  </li>
                </ul>
              </li>
              <li>
                <button
                  type="button"
                  class="flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                  aria-controls="dropdown-auth"
                  data-collapse-toggle="dropdown-auth"
                >
                  <svg
                    class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span
                    class="flex-1 ml-3 text-left whitespace-nowrap"
                    sidebar-toggle-item
                  >Authentication</span>
                  <svg
                    sidebar-toggle-item
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <ul
                  id="dropdown-auth"
                  class="hidden py-2 space-y-2"
                >
                  <li>
                    <a
                      href="./authentication/sign-in.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Sign
                      in</a>
                  </li>
                  <li>
                    <a
                      href="./authentication/sign-up.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Sign
                      up</a>
                  </li>
                  <li>
                    <a
                      href="./authentication/forgot-password.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Forgot
                      password</a>
                  </li>
                  <li>
                    <a
                      href="./authentication/reset-password.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Reset
                      password</a>
                  </li>
                  <li>
                    <a
                      href="./authentication/profile-lock.html"
                      class="flex items-center p-2 pl-11 text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100  "
                    >Profile
                      lock</a>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="pt-2 space-y-2">
              <a
                href="https://flowbite.com/docs/getting-started/introduction/"
                target="_blank"
                class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group  "
              >
                <svg
                  class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                  <path
                    fill-rule="evenodd"
                    d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span
                  class="ml-3"
                  sidebar-toggle-item
                >Docs</span>
              </a>
              <a
                href="https://flowbite.com/docs/components/alerts/"
                target="_blank"
                class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group  "
              >
                <svg
                  class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"
                  />
                </svg>
                <span
                  class="ml-3"
                  sidebar-toggle-item
                >Components</span>
              </a>
              <a
                href="https://github.com/themesberg/flowbite/issues"
                target="_blank"
                class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 group  "
              >
                <svg
                  class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900  "
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span
                  class="ml-3"
                  sidebar-toggle-item
                >Help</span>
              </a>
            </div>
          </div>
        </div>
        <div
          class="hidden absolute bottom-0 left-0 justify-center p-4 space-x-4 w-full lg:flex"
          sidebar-bottom-menu
        >
          <a
            href="#"
            class="inline-flex justify-center p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100  "
          >
            <svg
              class="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
              />
            </svg>
          </a>
          <a
            href="../../users/settings/"
            data-tooltip-target="tooltip-settings"
            class="inline-flex justify-center p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100  "
          >
            <svg
              class="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                clip-rule="evenodd"
              />
            </svg>
          </a>
          <div
            id="tooltip-settings"
            role="tooltip"
            class="inline-block absolute invisible z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 tooltip "
          >
            Settings page
            <div
              class="tooltip-arrow"
              data-popper-arrow
            />
          </div>
          <button
            type="button"
            data-dropdown-toggle="language-dropdown"
            class="inline-flex justify-center p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100  "
          >
            <svg
              class="h-5 w-5 rounded-full mt-0.5"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 3900 3900"
            >
              <path
                fill="#b22234"
                d="M0 0h7410v3900H0z"
              />
              <path
                d="M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0"
                stroke="#fff"
                stroke-width="300"
              />
              <path
                fill="#3c3b6e"
                d="M0 0h2964v2100H0z"
              />
              <g fill="#fff">
                <g id="d">
                  <g id="c">
                    <g id="e">
                      <g id="b">
                        <path
                          id="a"
                          d="M247 90l70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
                        />
                        <use
                          xlink:href="#a"
                          y="420"
                        />
                        <use
                          xlink:href="#a"
                          y="840"
                        />
                        <use
                          xlink:href="#a"
                          y="1260"
                        />
                      </g>
                      <use
                        xlink:href="#a"
                        y="1680"
                      />
                    </g>
                    <use
                      xlink:href="#b"
                      x="247"
                      y="210"
                    />
                  </g>
                  <use
                    xlink:href="#c"
                    x="494"
                  />
                </g>
                <use
                  xlink:href="#d"
                  x="988"
                />
                <use
                  xlink:href="#c"
                  x="1976"
                />
                <use
                  xlink:href="#e"
                  x="2470"
                />
              </g>
            </svg>
          </button>

          <div
            id="language-dropdown"
            class="hidden z-50 my-4 text-base list-none bg-white rounded divide-y divide-gray-100 shadow "
          >
            <ul
              class="py-1"
              role="none"
            >
              <li>
                <a
                  href="#"
                  class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100  "
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <svg
                      id="flag-icon-css-us"
                      class="h-3.5 w-3.5 rounded-full mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <g fill-rule="evenodd">
                        <g stroke-width="1pt">
                          <path
                            fill="#bd3d44"
                            d="M0 0h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0z"
                            transform="scale(3.9385)"
                          />
                          <path
                            fill="#fff"
                            d="M0 10h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0z"
                            transform="scale(3.9385)"
                          />
                        </g>
                        <path
                          fill="#192f5d"
                          d="M0 0h98.8v70H0z"
                          transform="scale(3.9385)"
                        />
                        <path
                          fill="#fff"
                          d="M8.2 3l1 2.8H12L9.7 7.5l.9 2.7-2.4-1.7L6 10.2l.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7L74 8.5l-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 7.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 24.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 21.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 38.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 35.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 52.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 49.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 66.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 63.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9z"
                          transform="scale(3.9385)"
                        />
                      </g>
                    </svg>
                    English (US)
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100  "
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <svg
                      id="flag-icon-css-de"
                      class="h-3.5 w-3.5 rounded-full mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="#ffce00"
                        d="M0 341.3h512V512H0z"
                      />
                      <path d="M0 0h512v170.7H0z" />
                      <path
                        fill="#d00"
                        d="M0 170.7h512v170.6H0z"
                      />
                    </svg>
                    Deutsch
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100  "
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <svg
                      id="flag-icon-css-it"
                      class="h-3.5 w-3.5 rounded-full mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <g
                        fill-rule="evenodd"
                        stroke-width="1pt"
                      >
                        <path
                          fill="#fff"
                          d="M0 0h512v512H0z"
                        />
                        <path
                          fill="#009246"
                          d="M0 0h170.7v512H0z"
                        />
                        <path
                          fill="#ce2b37"
                          d="M341.3 0H512v512H341.3z"
                        />
                      </g>
                    </svg>
                    Italiano
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100  "
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <svg
                      id="flag-icon-css-cn"
                      class="h-3.5 w-3.5 rounded-full mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 512 512"
                    >
                      <defs>
                        <path
                          id="a"
                          fill="#ffde00"
                          d="M1-.3L-.7.8 0-1 .6.8-1-.3z"
                        />
                      </defs>
                      <path
                        fill="#de2910"
                        d="M0 0h512v512H0z"
                      />
                      <use
                        width="30"
                        height="20"
                        transform="matrix(76.8 0 0 76.8 128 128)"
                        xlink:href="#a"
                      />
                      <use
                        width="30"
                        height="20"
                        transform="rotate(-121 142.6 -47) scale(25.5827)"
                        xlink:href="#a"
                      />
                      <use
                        width="30"
                        height="20"
                        transform="rotate(-98.1 198 -82) scale(25.6)"
                        xlink:href="#a"
                      />
                      <use
                        width="30"
                        height="20"
                        transform="rotate(-74 272.4 -114) scale(25.6137)"
                        xlink:href="#a"
                      />
                      <use
                        width="30"
                        height="20"
                        transform="matrix(16 -19.968 19.968 16 256 230.4)"
                        xlink:href="#a"
                      />
                    </svg>
                    中文 (繁體)
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </aside>

    <div
      id="sidebarBackdrop"
      class="hidden fixed inset-0 z-10 bg-gray-900/50 /90"
    />
    <div
      id="main-content"
      class="overflow-y-auto relative w-full h-full bg-gray-50 lg:ml-64 "
    >
      <main>
        <div class="p-4 md:p-5">
          <div
            class="text-sm font-medium text-center text-gray-500 border-b border-gray-200  "
          >
            <ul class="flex flex-wrap -mb-px">
              <li
                class="me-2"
                @click="selectTab(0)"
              >
                <a
                  href="#"
                  class="inline-block p-4  border-b-2 rounded-t-lg active  "
                  aria-current="page"
                  :class=" {'text-blue-600 border-blue-600 ':tab==0, 'border-transparent ': tab!=0}"
                >Formulaires</a>
              </li>
              <li
                class="me-2"
                @click="selectTab(1)"
              >
                <a
                  href="#"
                  class="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 "
                  :class=" {'text-blue-600 border-blue-600 ':tab==1, 'border-transparent ': tab!=1}"
                >Tableau
                  1</a>
              </li>
              <li
                class="me-2"
                @click="selectTab(2)"
              >
                <a
                  href="#"
                  class="inline-block p-4 border-b-2   rounded-t-lg hover:text-gray-600 hover:border-gray-300 "
                  :class=" {'text-blue-600 border-blue-600 ':tab==2, 'border-transparent ': tab!=2}"
                >Tableau
                  2</a>
              </li>
            </ul>
          </div>
          <div class="  mb-6 w-full text-left flex flex-row items-center mt-3">
            <label
              for="default-input"
              class="block mb-2 text-lg font-bold text-gray-900  mr-3"
            >Titre du Formulaire
              : </label>
            <input
              id="default-input"
              v-model="title[tab]"
              type="text"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-96 p-2.5      "
              @input="onInputTitle"
            >
          </div>







          <div class="flex flex-row mt-3">
            <div class="w-6/12 flex flex-col  ">
              <div
                class="relative mx-auto border-gray-800  bg-gray-800 border-[14px] rounded-[2.5rem] h-[590px]    w-[410px]  "
              >
                <div
                  class="h-[32px] w-[3px] bg-gray-800  absolute -start-[17px] top-[72px] rounded-s-lg  "
                />
                <div
                  class="h-[46px] w-[3px] bg-gray-800  absolute -start-[17px] top-[124px] rounded-s-lg  "
                />
                <div
                  class="h-[46px] w-[3px] bg-gray-800  absolute -start-[17px] top-[178px] rounded-s-lg  "
                />
                <div
                  class=" h-[64px] w-[3px] bg-gray-800  absolute -end-[17px] top-[142px] rounded-e-lg  "
                />
                <div
                  class="rounded-[2rem] overflow-hidden h-[562px]   bg-gray-700  bg-gray-700"
                >
                  <headerComponent :title="title[tab]" />

                  <div
                    class="  h-[426px] md:h-[654px] w-96 bg-gray-700 overflow-y-auto"
                    style="padding-right: 0px;box-sizing: content-box; width:100%"
                  >
                    <draggable
                      ghost-class="ghost"
                      draggable=".item:not(.exclude-this-item)"
                      class="mt-4 w-full   min-h-96 border-1 border-solid items-start flex flex-col  bg-gray-700  mb-12 border-gray-300   py-2 h-96"
                      :list="lines[tab]"
                      item-key="name"
                      @start="onDragStart($event)"
                      @end="onDrop($event)"
                    >
                      <template #header2>
                        <div
                          class="   mb-2 w-full py-2 flex justify-center"
                          role="group"
                        >
                          <button
                            type="button"
                            class="  flex items-center justify-left px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300   focus:outline-none "
                            @click="onOpenList"
                          >
                            <i class="fa-solid fa-plus  mr-2" />
                            {{ labels['BUTTON_ADD'][lg] }} {{ parent }}
                          </button>
                        </div>
                      </template>

                      <template #item="{element, index}">
                        <div
                          class="w-full bg-gray-700  "
                          :class="{'exclude-this-item':(element?.type=='validate')}"
                        >
                          <dateComponent
                            v-if="element?.type=='date'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />
                          <temperatureComponent
                            v-if="element?.type=='number'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <editComponent
                            v-if="element?.type=='edit'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <htmlComponent
                            v-if="element?.type=='html'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <titleComponent
                            v-if="element?.type=='title'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <radioComponent
                            v-if="element?.type=='radio'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <tableComponent
                            v-if="element?.type=='table'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />



                          <signatureComponent
                            v-if="element?.type=='hand-signature'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <buttonComponent
                            v-if="element?.type=='button'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />


                          <photoComponent
                            v-if="element?.type=='take-photo'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />


                          <documentComponent
                            v-if="element?.type=='scan-doc'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <codeComponent
                            v-if="element?.type=='scan-code'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />

                          <avatarComponent
                            v-if="element?.type=='avatar'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @delete-item="deleteItem"
                          />
                          <validateComponent
                            v-if="element?.type=='validate'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @add-item="addItem"
                          />

                          <ghostComponent
                            v-if="element?.type=='ghost'"
                            :element="element"
                            :index="index"
                            :is-selected="selected==element?.id"
                            @select-item="selectItem"
                            @add-item="addItem"
                            @delete-item="deleteItem"
                          />
                        </div>
                      </template>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-6/12 flex flex-col   w-full px-6 overflow-y-auto">
              <dateComponentDetails
                v-if="getElement?.type=='date'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />
              <temperatureComponentDetails
                v-if="getElement?.type=='number'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />

              <avatarComponentDetails
                v-if="getElement?.type=='avatar'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />

              <editComponentDetails
                v-if="getElement?.type=='edit'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />
              <titleComponentDetails
                v-if="getElement?.type=='title'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />

              <signatureComponentDetails
                v-if="getElement?.type=='hand-signature'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />


              <htmlComponentDetails
                v-if="getElement?.type=='html'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />


              <buttonComponentDetails
                v-if="getElement?.type=='button'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />


              <photoComponentDetails
                v-if="getElement?.type=='take-photo'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />


              <documentComponentDetails
                v-if="getElement?.type=='scan-doc'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />



              <codeComponentDetails
                v-if="getElement?.type=='scan-code'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />


              <radioComponentDetails
                v-if="getElement?.type=='radio'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />


              <tableComponentDetails
                v-if="getElement?.type=='table'"
                :element="getElement"
                @update="updateItem"
                @add="addItemAfter"
              />

              <validateComponentDetails
                v-if="getElement?.type=='validate'"
                :element="getElement"
                @update="updateItem"
              />

              <ghostComponentDetails
                v-if="getElement?.type=='ghost'"
                :element="getElement"
                :index="selectItem.id"
                @select-type="selectType"
              />
            </div>
          </div>

          <button
            class="mt-3 text-white inline-flex w-36 justify-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center   "
            @click="closeDialog"
          >
            Annuler
          </button>
          <button
            class="mt-3 ml-3 text-white inline-flex w-36 justify-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center   "
            @click="saveForm"
          >
            Valider
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import service from "@/services/FullService.vue"

    import headerComponent from "@/components/form/components/HeaderTabletFormComponent.vue"
    import validateComponent from "@/components/form/components/ValidateTabletFormComponent.vue"
    import validateComponentDetails from "@/components/form/components/ValidateTabletFormComponentDetails.vue"

    import dateComponent from "@/components/form/components/DateTabletFormComponent.vue"
    import dateComponentDetails from "@/components/form/components/DateTabletFormComponentDetails.vue"

    import signatureComponent from "@/components/form/components/HandSignatureTabletFormComponent.vue"
    import signatureComponentDetails from "@/components/form/components/HandSignatureTabletFormComponentDetails.vue"

    import htmlComponent from "@/components/form/components/HtmlTabletFormComponent.vue"
    import htmlComponentDetails from "@/components/form/components/HtmlTabletFormComponentDetails.vue"

    import editComponent from "@/components/form/components/EditTabletFormComponent.vue"
    import editComponentDetails from "@/components/form/components/EditTabletFormComponentDetails.vue"

    import ghostComponent from "@/components/form/components/GhostTabletFormComponent.vue"
    import ghostComponentDetails from "@/components/form/components/GhostTabletFormComponentDetails.vue"

    import radioComponent from "@/components/form/components/RadioTabletFormComponent.vue"
    import radioComponentDetails from "@/components/form/components/RadioTabletFormComponentDetails.vue"

    import tableComponent from "@/components/form/components/TableTabletFormComponent.vue"
    import tableComponentDetails from "@/components/form/components/TableTabletFormComponentDetails.vue"

    import titleComponent from "@/components/form/components/TitleTabletFormComponent.vue"
    import titleComponentDetails from "@/components/form/components/TitleTabletFormComponentDetails.vue"

    import temperatureComponent from "@/components/form/components/TemperatureTabletFormComponent.vue"
    import temperatureComponentDetails from "@/components/form/components/TempératureTabletFormComponentDetails.vue"

    import buttonComponent from "@/components/form/components/ButtonTabletFormComponent.vue"
    import buttonComponentDetails from "@/components/form/components/ButtonTabletFormComponentDetails.vue"

    import photoComponent from "@/components/form/components/PhotoTabletFormComponent.vue"
    import photoComponentDetails from "@/components/form/components/PhotoTabletFormComponentDetails.vue"

    import codeComponent from "@/components/form/components/CodeTabletFormComponent.vue"
    import codeComponentDetails from "@/components/form/components/CodeTabletFormComponentDetails.vue"

    import documentComponent from "@/components/form/components/DocumentTabletFormComponent.vue"
    import documentComponentDetails from "@/components/form/components/DocumentTabletFormComponentDetails.vue"

    import avatarComponent from "@/components/form/components/AvatarTabletFormComponent.vue"
    import avatarComponentDetails from "@/components/form/components/AvatarTabletFormComponentDetails.vue"

    import labels from "@/assets/lg/product-types.json"
    import { mapGetters } from "vuex";
    export default {
        name: 'FormEditorView',
        components: {
            draggable, headerComponent, validateComponent, dateComponent, tableComponent, tableComponentDetails, temperatureComponent, avatarComponent, dateComponentDetails, temperatureComponentDetails, avatarComponentDetails, editComponent, editComponentDetails, titleComponent, titleComponentDetails, radioComponent, radioComponentDetails, validateComponentDetails, ghostComponent, ghostComponentDetails, signatureComponent, signatureComponentDetails, buttonComponent, buttonComponentDetails, photoComponent, photoComponentDetails, documentComponent, documentComponentDetails, codeComponent, codeComponentDetails, htmlComponent, htmlComponentDetails
        },
        props: {
            profile: Object
        },
        data() {
            return ({
                lg: "FR",
                labels: labels,
                selected: "0",
                title: [""],
                tab: 0,
                lines: [],
                record: {},
                drag: false,
                types: []
            })
        },
        computed: {
            ...mapGetters({ user: "StateUser" }),
            isLoggedIn: function () {
                return this.$store.getters.isAuthenticated;
            },
            getElement: function () {
                if (this.selected == "0") return null
                let selected = this.selected;

                if (this.lines == undefined) {
                   
                    return;
                }
                let item = this.lines[this.tab].find(function (a) { return a.id == selected })

                return item
            }
        },
       
        watch: {
            "$route.params.id": async function () {
                await this.loadForm();
            },
            profile: function () {
             
                if (this.profile == undefined) return;
            
                this.lines[0] = this.profile.lines;
                this.title[0] = this.profile.title;
                this.title[1] = "";
                this.lines[1] = [{
                    id: "98",
                    title: "Valider",
                    type: "validate",
                    format: "relative",
                    suffix: "none",
                    prefix: "none"
                }]

                this.lines[2] = [{
                    id: "98",
                    title: "Valider!",
                    type: "validate",
                    format: "relative",
                    suffix: "none",
                    prefix: "none"
                }]

                 
            },
            lines: function () {
                this.$emit("update", { lines: this.lines, title: this.title })
            }
        },
        async mounted() {
            let collection = "data-sources/668cef0f9535b23c096b6408/records"
      //      let collection = "product-templates"
            let types = await service.getData(collection, this.user?.token, {})

            if (types != null) this.types = types.records;

            if (this.profile != undefined) {
                this.lines[0] = this.profile.lines;
                this.lines[1] = [{
                    id: "98",
                    title: "Valider",
                    type: "validate",
                    format: "relative",
                    suffix: "none",
                    prefix: "none"
                }];
                this.lines[2] = [{
                    id: "98",
                    title: "Valider",
                    type: "validate",
                    format: "relative",
                    suffix: "none",
                    prefix: "none"
                }];
                this.title[0] = this.profile.title;
                this.title[1] = "***************************";
            }
            else {
                this.lines[0] = [{
                    id: "98",
                    title: "Valider",
                    type: "validate",
                    format: "relative",
                    suffix: "none",
                    prefix: "none"
                }];
                this.lines[1] = [{
                    id: "98",
                    title: "Valider",
                    type: "validate",
                    format: "relative",
                    suffix: "none",
                    prefix: "none"
                }];
                this.lines[2] = [{
                    id: "98",
                    title: "Valider",
                    type: "validate",
                    format: "relative",
                suffix: "none",
                    prefix: "none"
                }];
                this.title[0] = "";
                this.title[1] = "***************************";
            }
       
            await  this.loadForm();
       
       
        },

        methods: {
            loadForm: async function () {
                let id = this.$route.params.id;

                if (this.user == undefined) {
                    //this.$router.push("/login");
                    window.location = "/login?redirect=/admin/editor/forms/" + id;
                    return;
                }

                this.record = await service.getDataId("forms", id, this.user?.token)
            },
            selectTab: function (index) {
                this.tab = index
            },
            onDragStart: function (event) {
              
                this.drag = true
                event.stopPropagation()
            },
            onDrop: function (event) {
              
                this.drag = false
                event.stopPropagation()
            },
            controlForm() {
                return true;
            },
            closeDialog() {

                this.$emit("close", null)
            },

            saveForm() {
                if (!this.controlForm()) {
                    alert("Error on Form");
                    return;
                }


                this.$emit("save", { lines: this.lines, title: this.title[0] })
            },


            addItemAfter(item) {

            
                let index = this.lines[this.tab].findIndex(function (a) { return a.id == item.id })
           
                if (index == -1) return;


                let newLine = {
                    id: 100 + 500 * this.tab + this.lines[this.tab].length,
                    title: "xxxxxxxxxx",
                    type: "ghost",
                    format: "text",
                    isRequired: true,
                    isDisplayScan: false,
                    isTitleDisplayed: true
                }
           

                this.lines[this.tab].splice(index + 1, 0, newLine);
                this.selected = newLine.id
            },

            selectType(item) {
                let model = {}

                let index = this.lines[this.tab].findIndex(function (a) { return a.id == item.id })

                if (index == -1) return;
                let id = item.id;

                switch (item.type) {
                    case 'date': model = { id: id.toString(), title: "Sélection Date", type: "date", format: "date-time", isRequired: true, isTitleDisplayed: true }; break;
                    case 'avatar': model = { id: id, title: "Titre de l'élement", type: "avatar", data: "", source: { id: "", name: "" }, filter: "", isRequired: true, isTitleDisplayed: true }; break;
                    case 'edit': model = { id: id, title: "Titre pour saisie", type: "edit", format: "text", isRequired: true, isDisplayScan: false, isTitleDisplayed: true }; break;
                    case 'title': model = { id: id, title: "Example de Titre", type: "title", format: "default", isTitleDisplayed: true }; break;
                    case 'radio': model = { id: id, title: "Titre de la lise de choix", type: "radio", data: "", values: [{ title: "Choix 1", value: "", default: "on" }, { title: "Choix 2", value: "", default: "off" }, { title: "Choix 3", value: "", default: "off" }], isRequired: true, isTitleDisplayed: true }; break;
                    case 'number': model = { id: id, title: "Titre liste de nombres", type: "number", format: "temperature", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                    case 'hand-signature': model = { id: id, title: "Signature", type: "hand-signature", format: "number", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                    case 'button': model = { id: id, title: "Titre bouton", type: "button", label: "button", action: "take-photo", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                    case 'html': model = { id: id, title: "Titre HTML", type: "html", body: "<b>hello</b>", href:null, isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                    case 'table': model = { id: id, title: "Titre du tableau", type: "table", columns: [], values: [], isRequired: true, data: "", isTitleDisplayed: true, }; break;
                    case 'bt':  model = { id: id, title: "Titre bouton", type: "button", label: "button", action: "navigate", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                 
                    case 'take-photo': model = { id: id, title: "Titre Prendre une photo", type: "take-photo", action: "", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                    case 'scan-doc': model = { id: id, title: "Titre Scanner un document", type: "scan-doc", action: "", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;
                    case 'scan-code': model = { id: id, title: "Titre Scanner un code", type: "scan-code", action: "", isRequired: true, data: "", displayStepValue: "1", isTitleDisplayed: true, minValue: "", maxValue: "", minDisplayValue: "0", maxDisplayValue: "15" }; break;

                }

                this.lines[this.tab][index] = model;
            },
            addItem(/*index*/) {
             
                let newLine = {
                    id: 100 + 500 * this.tab + this.lines[this.tab].length,
                    title: "xxxxxxxxxx",
                    type: "ghost",
                    format: "text",
                    isRequired: true,
                    isDisplayScan: false,
                    isTitleDisplayed: true
                }



                this.lines[this.tab].splice(this.lines[this.tab].length - 1, 0, newLine);
                this.selected = newLine.id

                //   this.$emit("update", { lines: this.lines[0], title: this.title })

            },

            deleteItem(index) {

                if (index == undefined) return;
                this.lines[this.tab].splice(index, 1)
            },
            updateItem(event) {
            
                let selected = this.selected;
                let item = this.lines[this.tab].find(function (a) { return a.id == selected })
                if (item == undefined) return;
                item[event.att] = event.value
            },
            selectItem(item) {
                this.selected = item.id
            },
            onProductSelect(item) {
                this.$emit("select", item)
            },
            onClose() {
                this.$emit("close")
            }
        },
       
    }
</script>
<style>

</style>